<template>
  <div>
    <div class="ui-center p-3 column recuperar ui-center bloco-cadastro">
      <h1 class="ui-title f-32 titulo redefinir_title">Redefinir senha</h1>
      <div>
        <h4 class="ui-paragraph f-20 frase">Coloque sua nova senha</h4>
        <div class="bloco-input">
          <input
            class="ui-input login-input password"
            type="password"
            id="passwordCadastro"
            name="new_password"
            v-model="form.new_password"
            minlength="8"
            required
            @keyup.enter.prevent="sendForm()"
          />
          <i
            class="fa fa-eye-slash icon-recuperar"
            aria-hidden="true"
            id="eyesCadastro"
            onclick="mostrarSenha()"
          ></i>
        </div>
        <h4 class="ui-paragraph f-20 frase">Confirme sua nova senha</h4>
        <div class="bloco-input">
          <input
            class="ui-input login-input password"
            type="password"
            id="passwordCadastro2"
            name="new_password_confirmation"
            v-model="form.new_password_confirmation"
            minlength="8"
            required
            @keyup.enter.prevent="sendForm()"
          />
          <i
            class="fa fa-eye-slash icon-recuperar"
            aria-hidden="true"
            id="eyesCadastro2"
            onclick="mostrarSenha2()"
          ></i>
        </div>
        <button
          class="ui-button-yellow button"
          type="button"
          @click.prevent="sendForm()"
          v-html="btnSubmit.text"
          :disabled="btnSubmit.disabled"
        ></button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["token", "recovery_code"],
  data() {
    return {
      form: {
        new_password: "",
        new_password_confirmation: "",
        _recovery_code: this.recovery_code,
      },
      btnSubmit: {
        text: "Atualizar",
        disabled: false,
      },
    };
  },
  methods: {
    sendForm: function () {
      this.btnSubmit.text = "<div class='loader'></div>";
      this.btnSubmit.disabled = true;
      axios
        .post("/redefinir-senha-post", this.form)
        .then((res) => {
          this.$swal({
            title: res.data,
            type: "success",
            preConfirm: () => {
              window.location.href = "/login";
            },
          }).then((r) => {
            if (r.dismiss) {
              window.location.href = "/login";
            }
          });
        })
        .catch((e) => {
          this.$swal({
            title: e.response.data,
            type: "error",
          });
        })
        .finally((f) => {
          this.btnSubmit.text = 'Atualizar';
          this.btnSubmit.disabled = false;
        });
    },
  },
};
</script>
